import React, { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import PaginationTable from "components/PaginationTable";
import { API_ADMIN_CARDS_VIRTUAL } from "services/API/apiPaths";

const AdminVirtualCards = ({ adminId }) => {
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  const paginationTableRef = useRef();

  useEffect(() => {
    !isInitialLoad
      ? paginationTableRef.current.refetch()
      : setIsInitialLoad(false);
  }, [adminId]);

  const columns = useMemo(
    () => [
      {
        header: "Pep Card ID",
        accessorKey: "cardId",
        Cell: ({ cell, row }) => (
          <Link target="_blank" to={`/cards/${row.original.id}`}>
            {cell.getValue()}
          </Link>
        ),
      },
      {
        header: "Masked Card Number",
        accessorKey: "cardNumber",
      },
      {
        header: "Brand",
        accessorKey: "brand",
      },
      {
        header: "Card Name",
        accessorKey: "name",
      },
      {
        header: "Status",
        accessorKey: "status",
      },
      {
        header: "Created Time",
        accessorKey: "createdTime",
      },
    ],
    []
  );

  return (
    <PaginationTable
      ref={paginationTableRef}
      title="Agent Virtial Card List"
      apiEndpoint={API_ADMIN_CARDS_VIRTUAL}
      columns={columns}
      initialFilters={{ adminId: adminId }}
    />
  );
};

export default AdminVirtualCards;
